<template>
    <div>

        <Header class="text-center">
            <h2 class="margin-bottom-50">Resume Rewriting</h2>
            <p>
                Is your resume even being read by employers? – we can make sure that it is!</p>
            <p>
                We'll help you show potential employers why you are the best candidate for the position.
                Contact us today to speak to a writer, and have your resume ready to go in just a day or two!
            </p>
        </Header>

        <div class="container margin-bottom-100">
            <div class="row">
                <div class="col-xl-12">
                    <!-- Pricing Plans Container -->
                    <div class="pricing-plans-container">
                        <!-- Plan -->
                        <template>
                            <!-- <PricingCard @proceed="proceedToCheckout" v-for="item in packageList" :key="item.type.value"
                                :isRecommended="item.recommended" :description="item.description" :category="item.category"
                                :type="item.type" :amount="item.price" :features="item.features" :to="item.route">
                            </PricingCard> -->
                            <PricingCard @proceed="proceed(item)" v-for="item in packageList " :key="item.type.value"
                                :item="item">
                            </PricingCard>
                        </template>

                    </div>

                </div>

            </div>
        </div>
        <div ref="contact"></div>
        <div class="col-xl-8 col-lg-8 offset-xl-2 offset-lg-2" v-if="isContactOpen">
            <section id="contact" class="margin-bottom-60">
                <h3 class="headline margin-top-15 margin-bottom-35">Please leave your contact information below, and
                    we'll reach out to discuss your resume rewrite.
                </h3>
                <Form :initialSubject="subject" :initialMessage="message" :initialTo="to" :initialCc="cc"></Form>
            </section>
        </div>
        <Checkout v-if="isCheckOutOpen" :pricingDetails="pricingDetails">
        </Checkout>
    </div>
</template>

<script>
import PricingCard from "~/components/pricing/Card.vue";
import Header from '~/components/base/Header.vue';
import resume from '~/content/pricing/resume.json';
import Checkout from '~/components/dashboard/posts/CheckOut.vue';
import Form from '~/components/contact/Form.vue';

export default {
    components: {
        PricingCard,
        Header,
        Checkout,
        Form
    },
    data() {
        return {

            message: "I would like to get more information about your resume rewriting services.",
            selectedPackage: "Basic",
            to: "diti.pn@macherusa.com",
            cc: "hindy@quickwordsus.com",
            packageList: resume,
            pricingDetails: {},
            isContactOpen: false,
            isCheckOutOpen: false
        }
    },

    computed: {
        subject() {
            return this.selectedPackage + " Resume Rewriting - Info Requested";
        }
    },
    methods: {
        proceed(item) {
            if (this.$route.query.checkout)
                this.proceedToCheckout(item);
            else
                this.proceedToContact(item);
        },
        proceedToContact(item) {
            this.selectedPackage = item.type.name;
            this.isContactOpen = true;
            this.$refs["contact"].scrollIntoView({ behavior: "smooth" });
        },

        proceedToCheckout(item) {
            this.$refs["contact"].scrollIntoView({ behavior: "smooth" });
            this.isCheckOutOpen = true;
            this.pricingDetails = {
                totalPrice: item.price,
                itemDescription: item.type.name + " Resume Rewriting",
                // saving: 12,
                priceWithDiscount: item.price,
                unitPrice: item.price,
                type: item.type.value,
                itemId: 0,
                //totalDiscount: 12,
                //percentageDiscount: 1,
                selectedNumberOfAds: 1,
                userCredit: 1
            }

        }
    },
    head() {
        const { path = "" } = this.$route;

        const metaTitle = "Resume Rewriting | Macher Jobs";
        const metaDescription = "Is your resume even being read by employers? – we can make sure that it is!"
        const canonical = process.env.baseUrl + path;

        return {
            title: metaTitle,
            link: [{ rel: "canonical", href: canonical }],
            meta: this.createMetaTags({
                description: metaDescription,
                title: metaTitle,
                canonical,
                socialTitle: metaTitle,
                socialDescription: metaDescription,
                siteName: "Macher Jobs",
                twitter: "@FrumJewishJobs",
            }),
        };
    }
}
</script>

<style lang="scss" scoped>
.text-center {
    text-align: center;
}
</style>